import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class EmployeeEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "Employee";
        this.primaryEnterpriseComponent = "Employee";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "Employee";
        eom.enterpriseComponent = "Employee";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "EmployeeAdminRole";
        eom.enterpriseComponent = "EmployeeAdminRole";
        eom.relationship = "EmployeeEmployeeAdminRole";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "EmployeeAdminPosition";
        eom.enterpriseComponent = "EmployeeAdminPosition";
        eom.relationship = "EmployeeEmployeeAdminPosition";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "EmployeeAdminUserGroup";
        eom.enterpriseComponent = "EmployeeAdminUserGroup";
        eom.relationship = "EmployeeEmployeeAdminUserGroup";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "EmployeeAdminWorkGroup";
        eom.enterpriseComponent = "EmployeeAdminWorkGroup";
        eom.relationship = "EmployeeEmployeeAdminWorkGroup";
        this.enterpriseComponentMembers.set(eom.name, eom);

    }
}

export default EmployeeEnterpriseObjectMetadata;